import React from "react";
import Logo from "../../images/e-health_logo.png";
import Container from "../Container";
import ListComponent from "../utils/ListComponent";
import { NavigationItems } from "../utils/NavigationItems";
import { Link } from "gatsby";

export default function Footer() {
  return (
    <footer className="w-full py-12">
      <Container size="large">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
          {/* Logo */}
          <div className="flex justify-center md:justify-start">
            <img src={Logo} alt="e-Health Logo" className="h-12 w-auto" />
          </div>

          {/* Navigation Links */}
          <div className="flex justify-center md:justify-end">
            <ListComponent
              data={NavigationItems}
              renderItem={(item, i) => (
                <Link
                  key={i}
                  to="#"
                  className="px-3 py-1 text-sm hover:underline"
                >
                  {item.name}
                </Link>
              )}
            />
          </div>
        </div>
      </Container>
    </footer>
  );
}
